import { createTheme } from '@mui/material/styles'

const cosmosColor = '#03101D'
const cosmosColorRGB = '3, 16, 29'

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1800,
    },
  },
  typography: {
    fontFamily: 'League Spartan, Arial',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: () => ({
        body: {
          backgroundColor: '#EFECF1',
        },
        img: {
          WebkitUserDrag: 'none',
          KhtmlUserDrag: 'none',
          MozUserDrag: 'none',
          OUserDrag: 'none',
          userDrag: 'none',
        },
      }),
    },
  },
  palette: {
    text: {
      primary: cosmosColor,
    },
    common: {
      white: '#fafafa',
      black: '#000',
    },
    //Cosmos
    primary: {
      main: cosmosColor,
      light: 'rgb(196, 196, 196)',
    },
    //Lilac
    secondary: {
      main: '#E4CAFB',
      light: '#EFECF1',
    },
    light: {
      main: '#EFECF1',
    },
    background: {
      default: '#EFECF1',
    },
    sorbet: {
      main: '#FDFDA4',
    },
    peach: {
      main: '#EA9F7B',
    },
    mint: {
      main: '#AAD7D3',
    },
    error: {
      main: '#F03A3A',
    },
    grey: {
      50: `rgba(${cosmosColorRGB}, 0.05)`,
      100: `rgba(${cosmosColorRGB}, 0.1)`,
      200: `rgba(${cosmosColorRGB}, 0.2)`,
      300: `rgba(${cosmosColorRGB}, 0.3)`,
      400: `rgba(${cosmosColorRGB}, 0.4)`,
      500: `rgba(${cosmosColorRGB}, 0.5)`,
      600: `rgba(${cosmosColorRGB}, 0.6)`,
      700: `rgba(${cosmosColorRGB}, 0.7)`,
      800: `rgba(${cosmosColorRGB}, 0.8)`,
      900: `rgba(${cosmosColorRGB}, 0.9)`,
    },
  },
  shape: {
    borderRadius: 8,
  },
  custom: {
    sidebarWidth: 240,
    basePadding: 24,
    mobileAuthSupportHeight: 100,
    mobileAuthNavbarHeight: 64,
    mobileNavBarHeight: 64,
  },
})
